import L from 'leaflet';
import type { StallStatus } from '@/api/types';

/**
 * Build a Leaflet DivIcon for an OpenSoi stall pin. Uses the design-system
 * `.pin` and `.pin-pulse` CSS classes (shared with the prototype).
 */
export function buildPinIcon(status: StallStatus, fresh: boolean): L.DivIcon {
  const cls =
    status === 'open' ? 'pin open' : status === 'closed' ? 'pin closed' : 'pin';
  const pulse = fresh && status === 'open' ? '<div class="pin-pulse" aria-hidden="true"></div>' : '';
  return L.divIcon({
    className: 'opensoi-pin',
    html: `<div style="position:relative; width:28px; height:28px;">${pulse}<div class="${cls}"></div></div>`,
    iconSize: [28, 28],
    iconAnchor: [14, 28],
  });
}
